import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import {UserAuth} from "@/models/UserAuth";
import IngresoIndex from "@/views/ingreso/IngresoIndex.vue";
import IngresoNew from "@/views/ingreso/IngresoNew.vue";
import IngresoEdit from "@/views/ingreso/IngresoEdit.vue";
import MaterialesIndex from "@/views/Material/MaterialIndex.vue";
import BincardIndex from "@/views/bincard/BincardIndex.vue";
import ShowBincard from "@/views/bincard/ShowBincard.vue";
import MaterialNew from "@/views/Material/MaterialNew.vue";
import MaterialEdit from "@/views/Material/MaterialEdit.vue";
import SalidasIndex from "@/views/salidas/SalidasIndex.vue";
import SalidaNew from "@/views/salidas/SalidaNew.vue";
import SalidaEdit from "@/views/salidas/SalidaEdit.vue";
import ValeSalidasIndex from "@/views/valeSalida/valeSalidasIndex.vue";
import ValeGasolinaIndex from "@/views/salidaGasolina/valeGasolinaIndex.vue";
import ValeSalidaNew from "@/views/valeSalida/ValeSalidaNew.vue";
import ValeGasolinaNew from "@/views/salidaGasolina/ValeGasolinaNew.vue";
import BindCardIndexPeps from "@/views/bindCardPeps/BincardIndexPeps.vue";
import BindCardShowPeps from "@/views/bindCardPeps/ShowBincardPeps.vue";
import BincardIndexPeps from "@/views/bindCardPeps/BincardIndexPeps.vue";
import ShowBincardPeps from "@/views/bindCardPeps/ShowBincardPeps.vue";
import PrestamoMaterialesIndex from "@/views/prestamoMateriales/prestamoMaterialesIndex.vue";
import PrestamoMaterialNew from "@/views/prestamoMateriales/PrestamoMaterialNew.vue";
import ResumenIngresosCuentaContable from "@/views/reportes/IngresosCuentaContable.vue"
import ConsultaCantidadesCalculadasEntradaSalidaIniciales from "@/views/reportes/ConsultaCantidadesCalculadasEntradaSalidaIniciales.vue";
import SalidaNewManual from "@/views/salidas/SalidaNewManual.vue";
import EmpresaIndex from "@/views/empresa/EmpresaIndex.vue";
import EmpresaNew from "@/views/empresa/EmpresaNew.vue";
import EmpresaEdit from "@/views/empresa/EmpresaEdit.vue";
import PrestamoMaterialEdit from "@/views/prestamoMateriales/PrestamoMaterialEdit.vue";
import PlanchaMateriales from "@/views/planchaMateriales/PlanchaMateriales.vue";
import MaximosMinimosIndex from "@/views/maximosMinimos/MaximosMinimosIndex.vue";
import ReporteMaximosMinimos from "@/views/reportes/ReporteMaximosMinimos.vue";
import ReporteInventario from "@/views/inventario/ReporteInventario.vue";
import ReporteInventarioGeneral from "@/views/inventario/ReporteInventarioGeneral.vue";
import ValeSalidaEdit from "@/views/valeSalida/ValeSalidaEdit.vue";
import CompraMaterialesIndex from "@/views/compraMateriales/compraMaterialesIndex.vue"
import CompraMaterialesNew from "@/views/compraMateriales/CompraMaterialesNew.vue";
import CompraMaterialesEdit from "@/views/compraMateriales/CompraMaterialesEdit.vue";
import MisOrdenesIndex from "@/views/misordenes/MisOrdenesIndex.vue";

Vue.use(VueRouter)


const routes: Array<RouteConfig> = [
    {
        path: '/login/:user_id/:token_id',
        name: 'login',
        component: () => import('../views/usuarios/Login.vue'),
        meta: { requiresAuth: false }
    },

    {
        path: '/inventarioGeneral',
        name: 'inventarioGeneral',
        component: ReporteInventarioGeneral,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/bincard',
        name: 'bincard',
        component: BincardIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/showBincard',
        name: 'showBincard',
        component: ShowBincard,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },


    {
        path: '/bincardPeps',
        name: 'bincardPeps',
        component: BincardIndexPeps,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/showBincardPeps',
        name: 'showBincardPeps',
        component: ShowBincardPeps,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/empresas',
        name: 'empresas',
        component: EmpresaIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/empresaNew',
        name: 'empresaNew',
        component: EmpresaNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/empresaEdit',
        name: 'empresaEdit',
        component: EmpresaEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/maximosMinimosIndex',
        name: 'maximosMinimosIndex',
        component: MaximosMinimosIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/materiales',
        name: 'materiales',
        component: MaterialesIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/materialNew',
        name: 'materialNew',
        component: MaterialNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/materialEdit',
        name: 'materialEdit',
        component: MaterialEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/ingresos',
        name: 'ingresos',
        component: IngresoIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenKardex') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/ingresoNew',
        name: 'ingresoNew',
        component: IngresoNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/ingresoEdit',
        name: 'ingresoEdit',
        component: IngresoEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenKardex') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/salidas',
        name: 'salidas',
        component: SalidasIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenKardex') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/salidaNew',
        name: 'salidaNew',
        component: SalidaNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/salidaNewManual',
        name: 'salidaNewManual',
        component: SalidaNewManual,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/salidaEdit',
        name: 'salidaEdit',
        component: SalidaEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenKardex') || UserAuth.can('kardex')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/compraMateriales',
        name: 'compraMateriales',
        component: CompraMaterialesIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/compraMaterialesNew',
        name: 'compraMaterialesNew',
        component: CompraMaterialesNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/compraMaterialeslEdit',
        name: 'compraMaterialeslEdit',
        component: CompraMaterialesEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },



    {
        path: '/valesalidas',
        name: 'valesalidas',
        component: ValeSalidasIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/misOrdenes',
        name: 'misOrdenes',
        component: MisOrdenesIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/valesalidasNew',
        name: 'valesalidasNew',
        component: ValeSalidaNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/valeGasolina',
        name: 'valeGasolina',
        component: ValeGasolinaIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeGasolina')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/valeGasolinaNew',
        name: 'valeGasolinaNew',
        component: ValeGasolinaNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeGasolina')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/prestamoMateriales',
        name: 'prestamoMateriales',
        component: PrestamoMaterialesIndex,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('prestamomaterial')) next()
            else next({name: "error_permisos"})
        }
    },
    {
        path: '/prestamoMaterialNew',
        name: 'prestamoMaterialNew',
        component: PrestamoMaterialNew,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('prestamomaterial')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/prestamoMaterialEdit',
        name: 'prestamoMaterialEdit',
        component: PrestamoMaterialEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacenAdmin') || UserAuth.can('prestamomaterial')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/valeSalidalEdit',
        name: 'valeSalidalEdit',
        component: ValeSalidaEdit,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('valeSalida')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/planchaMateriales',
        name: 'planchaMateriales',
        component: PlanchaMateriales,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('almacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/resumenIngresoCuentaContable',
        name: 'resumenIngresoCuentaContable',
        component: ResumenIngresosCuentaContable,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('reportesAlmacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/cantidadesCalculadas',
        name: 'cantidadesCalculadas',
        component: ConsultaCantidadesCalculadasEntradaSalidaIniciales,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('reportesAlmacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/maximosminimos',
        name: 'maximosminimos',
        component: ReporteMaximosMinimos,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('reportesAlmacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/inventarioGeneral',
        name: 'inventarioGeneral',
        component: ReporteInventarioGeneral,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('reportesAlmacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/inventario',
        name: 'inventario',
        component: ReporteInventario,
        meta: {requiresAuth: true},
        beforeEnter: (to, from, next) => {
            if (UserAuth.can('reportesAlmacen')) next()
            else next({name: "error_permisos"})
        }
    },

    {
        path: '/404',
        name: 'error',
        component: () => import('../components/Error.vue'),
    },
    {
        path: '/403',
        name: 'error_permisos',
        component: () => import('../components/ErrorPermisos.vue'),
    },
    {
        path: '/',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (UserAuth.isLogin())
            next()
        else
            next('/403');
    }
    else
        next()
});

export default router
